import { Link } from "react-router-dom";

export default function Terminos() {
  return (
    <div className="min-h-screen bg-white flex flex-col items-center px-6 py-10">
      {/* Logo */}
      <Link to="/" className="mb-10">
        <img src="/noltrade_gpt.png" alt="Noltrade" className="h-12" />
      </Link>

      <div className="max-w-3xl w-full text-sm text-gray-700 space-y-4">
        <h1 className="text-2xl font-bold mb-4">Términos y Condiciones</h1>

        <p>
          Al acceder a Noltrade, aceptas estar sujeto a estos términos. Si no estás de acuerdo,
          por favor no uses el sitio.
        </p>

        <p className="font-semibold">1. Uso del sitio</p>
        <p>
          Este sitio permite a usuarios publicar, consultar y negociar negocios digitales y activos.
        </p>

        <p className="font-semibold">2. Privacidad y seguridad</p>
        <p>
          Protegemos tu información de acuerdo con nuestra política de privacidad. No compartas tus
          credenciales.
        </p>

        <p className="font-semibold">3. Limitación de responsabilidad</p>
        <p>
          Noltrade no se hace responsable por acuerdos fuera de la plataforma ni por la veracidad
          del contenido publicado por los usuarios.
        </p>

        <p className="text-xs text-gray-400">Última actualización: mayo 2025</p>

        {/* Botón opcional para volver */}
        <div className="pt-6">
          <Link
            to="/"
            className="text-sm text-yellow-600 hover:underline font-medium"
          >
            ← Volver al inicio
          </Link>
        </div>
      </div>
    </div>
  );
}
